import { FC } from "react";
import styled from "styled-components";
import Image from "next/legacy/image";
import { P1 } from "./Paragraph";
import { color as themeColor } from "@styles";
import AigLogo from "public/static/img/logos/aig-core-blue.svg";

export const Callout: FC<React.PropsWithChildren<unknown>> = () => (
  <CalloutContainer>
    <Flex>
      <ImageContainer>
        <Image src={AigLogo} alt="AIG" />
      </ImageContainer>
      <TextContainer>
        <P1 pt="0">
          Plans are provided by{" "}
          <AIGAnchor href="https://www.aiglife.co.uk" target="_blank" rel="noopener noreferrer">
            AIG Life Limited
          </AIGAnchor>
          , part of AIG Inc., a global insurance group.
        </P1>
      </TextContainer>
    </Flex>
  </CalloutContainer>
);

export const CalloutSpacer = styled.div`
  @media only screen and (max-width: 30rem) {
    height: 7rem;
  }
`;

const AIGAnchor = styled.a`
  display: inline;
  text-decoration: underline;
  color: #5c5757;

  &:hover {
    color: ${themeColor.P100};
  }
`;

const CalloutContainer = styled.div`
  position: relative;
  display: inline-block;
  padding: 1rem 1.25rem;
  margin: -0.5rem 1.25rem 0 1.25rem;
  max-width: 46.43rem;
  background: #ffffff;
  border: 0.125rem solid #d9d9d7;
  box-sizing: border-box;
  border-radius: 0.5rem;
  box-shadow: 0.5rem 0.5rem 0 0 rgba(160, 160, 155, 0.24);

  @media only screen and (max-width: 45rem) {
    text-align: center;
    padding: 1.75rem 0.5rem;
  }

  @media only screen and (max-width: 30rem) {
    transform: translateY(-2rem);
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;

  @media only screen and (max-width: 45rem) {
    display: block;
  }
`;

const ImageContainer = styled.div`
  padding: 1rem 1.25rem;
  flex-shrink: 0;

  img {
    margin: auto;
    height: 3.5rem;
    width: 7.054rem;
    object-fit: contain;
  }
`;

const TextContainer = styled.div`
  padding: 1rem 1.25rem;

  @media only screen and (max-width: 45rem) {
    padding: 1.25rem 0.5rem 0 0.5rem;
  }
`;

export const AIGLogo = () => {
  return (
    <svg
      width="104"
      height="56"
      viewBox="0 0 104 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 28.0005V56H51.9877H103.975V28.0005V2.12388e-07H51.9877H0V28.0005ZM100.075 28.0005V52.0529H51.9575H3.83938V28.0005V3.94707H51.9565H100.074V28.0005H100.075Z"
        fill="#00A4E4"
      />
      <path
        d="M75.4888 11.7548C74.1572 11.8722 72.6403 12.1742 71.4761 12.5506C69.0174 13.34 67.1348 14.4871 65.3018 16.3127C63.184 18.4219 61.8152 20.8335 61.0537 23.7815C60.6326 25.4407 60.5395 26.2361 60.5395 28.2466C60.5336 30.0721 60.5831 30.5719 60.8739 31.9904C61.3881 34.4573 62.5954 36.943 64.2055 38.8548C64.8371 39.6013 66.1995 40.9211 66.8995 41.4639C69.1848 43.2341 71.8724 44.2826 74.9439 44.5909C76.0526 44.7083 78.4736 44.6403 79.4521 44.4735C81.8052 44.0665 83.8859 43.203 85.6198 41.9015C88.0785 40.0572 89.9546 37.3624 90.8464 34.3897C91.3418 32.7305 91.5275 31.4294 91.5711 29.1845L91.6083 27.5687H85.0318H78.4613V29.82V32.0708H82.4245C85.552 32.0708 86.3877 32.0896 86.3877 32.1448C86.3877 32.3363 86.0097 33.6867 85.8363 34.1248C85.1428 35.858 83.9414 37.4122 82.5171 38.4172C81.9162 38.8366 80.7213 39.441 80.0708 39.6507C77.5195 40.4712 74.5099 40.2304 71.9893 39.0029C68.8123 37.461 66.577 34.482 65.8646 30.8497C65.4123 28.5431 65.5921 25.9282 66.3476 23.7756C67.8091 19.6065 71.1966 16.8741 75.5686 16.3378C76.4851 16.2268 78.5039 16.2944 79.3525 16.4676C82.1639 17.029 84.5978 18.5832 86.4184 20.9884L86.7776 21.4695L87.2175 21.0437C87.4593 20.8153 88.2272 20.0816 88.9267 19.4215C89.6262 18.7613 90.2023 18.2063 90.2147 18.188C90.2519 18.1017 89.2175 16.8929 88.5487 16.2451C86.9014 14.6475 84.6969 13.3153 82.4859 12.5817C80.6901 11.9832 79.3896 11.7735 77.2842 11.7489C76.4489 11.7424 75.6439 11.7424 75.4888 11.7548Z"
        fill="#00A4E4"
      />
      <path
        d="M27.6011 12.7786C27.5204 12.9577 24.1457 20.093 20.1017 28.6286C16.0637 37.171 12.7568 44.1711 12.7568 44.1894C12.7568 44.2081 13.9458 44.214 15.4013 44.2081L18.0393 44.1894L19.7797 40.3533L21.52 36.5173L28.2699 36.5113H35.0262L36.7047 40.3474L38.3831 44.1899L41.0211 44.2086C42.4702 44.215 43.6591 44.2022 43.6591 44.1839C43.6591 44.1346 43.8573 44.5727 33.596 21.8021C32.1777 18.6444 30.6607 15.2894 30.2396 14.3397C29.8121 13.3899 29.4346 12.5758 29.4034 12.5324C29.3539 12.4831 29.1062 12.4584 28.5488 12.4584H27.7497L27.6011 12.7786ZM30.685 26.4892C31.93 29.2956 32.9391 31.6081 32.9267 31.6204C32.9143 31.6328 30.8212 31.6328 28.2823 31.6263L23.6627 31.6076L26.0223 26.471C27.3168 23.6464 28.3878 21.3457 28.4002 21.3581C28.4126 21.3704 29.4406 23.6765 30.685 26.4892Z"
        fill="#00A4E4"
      />
      <path
        d="M49.1074 28.5245V44.1588H51.5225H53.9376V28.5245V12.8901H51.5225H49.1074V28.5245Z"
        fill="#00A4E4"
      />
    </svg>
  );
};
